import React, { useState, useEffect } from 'react';
import axios from 'axios';
import SEO from '../components/SEO';
import './Reviews.css';

function Reviews({ user }) {
  const [reviews, setReviews] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showForm, setShowForm] = useState(false);
  const [formData, setFormData] = useState({
    server: '',
    text: '',
    rating: 5
  });

  useEffect(() => {
    fetchReviews();
  }, []);

  const fetchReviews = async () => {
    try {
      const response = await axios.get('/api/reviews');
      setReviews(response.data);
    } catch (error) {
      console.error('Error fetching reviews:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!user) {
      alert('Необходимо войти через Steam');
      return;
    }

    try {
      await axios.post('/api/reviews', formData);
      setFormData({ server: '', text: '', rating: 5 });
      setShowForm(false);
      fetchReviews();
      alert('Отзыв отправлен на модерацию');
    } catch (error) {
      console.error('Error submitting review:', error);
      alert('Ошибка при отправке отзыва');
    }
  };

  if (loading) {
    return <div className="loading">Загрузка отзывов...</div>;
  }

  return (
    <div className="reviews">
      <SEO 
        title="Отзывы о OptimizeRust - Реальные отзывы администраторов серверов Rust"
        description="Читайте отзывы администраторов серверов Rust о плагине OptimizeRust. Реальные результаты оптимизации и повышения FPS на серверах."
        keywords="отзывы optimizerust, отзывы rust плагин, отзывы оптимизация rust, результаты optimizerust"
      />
      <section className="section">
        <div className="container">
          <h1 className="section-title">Отзывы</h1>
          <p className="section-subtitle">
            Что говорят администраторы серверов о OptimizeRust
          </p>

          {user && (
            <div className="review-form-toggle">
              <button 
                onClick={() => setShowForm(!showForm)} 
                className="btn btn-primary"
              >
                {showForm ? 'Закрыть форму' : 'Оставить отзыв'}
              </button>
            </div>
          )}

          {showForm && user && (
            <form className="review-form" onSubmit={handleSubmit}>
              <div className="form-group">
                <label>Название сервера</label>
                <input
                  type="text"
                  value={formData.server}
                  onChange={(e) => setFormData({ ...formData, server: e.target.value })}
                  required
                  placeholder="Например: My Rust Server"
                />
              </div>
              <div className="form-group">
                <label>Оценка</label>
                <select
                  value={formData.rating}
                  onChange={(e) => setFormData({ ...formData, rating: parseInt(e.target.value) })}
                  required
                >
                  <option value={5}>5 - Отлично</option>
                  <option value={4}>4 - Хорошо</option>
                  <option value={3}>3 - Удовлетворительно</option>
                  <option value={2}>2 - Плохо</option>
                  <option value={1}>1 - Очень плохо</option>
                </select>
              </div>
              <div className="form-group">
                <label>Отзыв</label>
                <textarea
                  value={formData.text}
                  onChange={(e) => setFormData({ ...formData, text: e.target.value })}
                  required
                  rows="6"
                  placeholder="Опишите ваш опыт использования плагина..."
                  maxLength={1000}
                />
              </div>
              <button type="submit" className="btn btn-primary">
                Отправить на модерацию
              </button>
            </form>
          )}

          <div className="reviews-list">
            {reviews.length === 0 ? (
              <p className="no-reviews">Пока нет отзывов</p>
            ) : (
              reviews.map((review) => (
                <div key={review._id} className="review-card">
                  <div className="review-header">
                    <img 
                      src={review.avatar || '/default-avatar.png'} 
                      alt={review.username}
                      className="review-avatar"
                    />
                    <div className="review-user-info">
                      <div className="review-username">{review.username}</div>
                      <div className="review-server">{review.server}</div>
                    </div>
                    <div className="review-rating">
                      {'★'.repeat(review.rating)}
                      {'☆'.repeat(5 - review.rating)}
                    </div>
                  </div>
                  <div className="review-text">{review.text}</div>
                  <div className="review-date">
                    {new Date(review.createdAt).toLocaleDateString('ru-RU')}
                  </div>
                </div>
              ))
            )}
          </div>
        </div>
      </section>
    </div>
  );
}

export default Reviews;

